export default "__VITE_ASSET__BLwqKcKI__"